import s from './FooterTop.module.scss';
import { Link } from 'react-router-dom';
import T from '@data/text/footer.json';
// import SvgIcon from '@components/shared/icon/svgIcon/SvgIcon';
// import { ActionIcon } from '@components/shared/actionIcon/ActionIcon';
import { useSelector } from 'react-redux';
import { getIsLoggedIn } from '@store/auth/auth-selectors';
import { ROUTES } from '@configs/routeConstants';
import useMetrics from '@hooks/useMetrics';
import { METRIC_EVENTS, METRIC_EVENTS_TRIGGERS } from '@configs/metrics/events';
import { getCurrentThemeFromDom, normalizeTheme } from '@configs/themeAssets';
import { useCompanyTheme } from '@hooks/useCompanyTheme';
import { getWhiteLabelJsonThemeKey } from '@utils/companyTheme';
import React from 'react';

type FooterTopProps = unknown;

export const FooterTop = (_props: FooterTopProps) => {
  const isLoggedIn = useSelector(getIsLoggedIn);

  const { trackEvent } = useMetrics();

  const handleMainPageClick = () =>
    trackEvent(METRIC_EVENTS.main_page, METRIC_EVENTS_TRIGGERS.footer);
  const handleContactsClick = () =>
    trackEvent(METRIC_EVENTS.contacts_page, METRIC_EVENTS_TRIGGERS.footer);
  const handleQaBlockClick = () =>
    trackEvent(METRIC_EVENTS.qa_block, METRIC_EVENTS_TRIGGERS.footer);
  const handleSignInClick = () =>
    trackEvent(METRIC_EVENTS.auth_enter, METRIC_EVENTS_TRIGGERS.footer);

  const company = useCompanyTheme();


  const theme =
    getCurrentThemeFromDom() ??
    normalizeTheme(company) ??
    null;
  const contacts = T.contactsByTheme[getWhiteLabelJsonThemeKey(theme)];


  return (
    <div className={s.footerTop}>
      <div className={s.container}>
        {/* — навигация — */}
        <div className={s.topLeftSection}>
          <nav>
            <ul className={s.navList}>
              <li>
                <Link to={ROUTES.root} onClick={handleMainPageClick}>
                  {T.nav.home}
                </Link>
              </li>
              <li>
                <Link to={ROUTES.contacts} onClick={handleContactsClick}>
                  {T.nav.contacts}
                </Link>
              </li>
              <li>
                <Link to={ROUTES.faq} onClick={handleQaBlockClick}>
                  {T.nav.faq}
                </Link>
              </li>
            </ul>
          </nav>
          <div>
            {!isLoggedIn && (
              <Link className={s.buttons} to={ROUTES.signin} onClick={handleSignInClick}>
                <span className={s.link}>{T.nav.login}</span>
              </Link>
            )}
            {/* <Link to={ROUTES.mobileApp}>
              <Button
                variant="outline"
                color="yellow"
                rightIcon={<SvgIcon name="download-icon" height={22} width={22} />}
              >
                Сохранить на телефон
              </Button>
            </Link> */}
          </div>
        </div>

        {/* — email — */}
        <div className={s.topRightSection}>
          <a href={contacts.mailLink}>
            <span className={s.textEmail}>{contacts.mail}</span>
          </a>

          {/*<div className={s.footerSocialLinks}>*/}
          {/*  <a*/}
          {/*    className={s.socialLinksLink}*/}
          {/*    href={ROUTES.external.telegram}*/}
          {/*    target="_blank"*/}
          {/*    rel="noreferrer"*/}
          {/*  >*/}
          {/*    <ActionIcon>*/}
          {/*      <SvgIcon name="icon-telegram" height={18} width={18} />*/}
          {/*    </ActionIcon>*/}
          {/*  </a>*/}
          {/*  <a*/}
          {/*    className={s.socialLinksLink}*/}
          {/*    href={ROUTES.external.vk}*/}
          {/*    target="_blank"*/}
          {/*    rel="noreferrer"*/}
          {/*  >*/}
          {/*    <ActionIcon>*/}
          {/*      <SvgIcon name="icon-vk" height={11} width={18} />*/}
          {/*    </ActionIcon>*/}
          {/*  </a>*/}
          {/*  <a*/}
          {/*    className={s.socialLinksLink}*/}
          {/*    href={ROUTES.external.dzen}*/}
          {/*    target="_blank"*/}
          {/*    rel="noreferrer"*/}
          {/*  >*/}
          {/*    <ActionIcon>*/}
          {/*      <SvgIcon name="icon-dzen" height={16} width={16} />*/}
          {/*    </ActionIcon>*/}
          {/*  </a>*/}
          {/*</div>*/}
        </div>
      </div>
    </div>
  );
};
